import { IAppState } from '../../../../AppModulesWrapper';

export function selectPromotionTypeChangeReason(state: IAppState): null | string {
  return state.servicePickerWidget.publishTerms.promotionTypeChangeReason;
}
